"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./index.module.css");
var classNames = require("classnames");
var Ripple_1 = require("../Ripple");
var Button = function (_a) {
    var style = _a.style, _b = _a.size, size = _b === void 0 ? 'medium' : _b, _c = _a.color, color = _c === void 0 ? 'black' : _c, _d = _a.variant, variant = _d === void 0 ? 'text' : _d, children = _a.children, _e = _a.disabled, disabled = _e === void 0 ? false : _e, className = _a.className, otherProps = __rest(_a, ["style", "size", "color", "variant", "children", "disabled", "className"]);
    return (React.createElement("button", __assign({ style: style, "data-size": size, "data-color": color, "data-disabled": disabled, "data-variant": variant, className: classNames(styles.button, className, disabled && styles.disabled, styles[size], styles[variant], styles[color]) }, otherProps),
        React.createElement("span", { className: styles.children }, children),
        !disabled && React.createElement(Ripple_1.default, null)));
};
exports.default = Button;
